var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-breadcrumb',[_vm._l((_vm.items.breadcrumb),function(item,index){return _c('b-breadcrumb-item',{key:index,attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.text)+" ")])}),_c('b-breadcrumb-item',{attrs:{"active":""}},[_vm._v(" "+_vm._s(_vm.activeTitle)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }